import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    computed: {
        ...mapGetters('label', ['labels']),
    },

    methods: {
        ...mapActions('label', ['getLabelListIfNecessary']),

        refreshLabelList: _.debounce(function(query) {
            this.getLabelListIfNecessary({ query: query });
        }, 500),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/label.js